import { SvgIcon, SvgIconProps } from '@mui/material';
import './ccf-work-item-icon.module.scss';

/* eslint-disable-next-line */
export interface CcfWorkItemIconProps extends SvgIconProps {}

/**
 * Component used to return wotkitem icon
 * @param props -
 * @example
 * @returns
 */
export function CcfWorkItemIcon(props: CcfWorkItemIconProps) {
  return (
    <SvgIcon {...props} width="16" height="20" viewBox="0 0 16 20">
      <g id="work item">
        <g id="Union">
          <path
            d="M10 5.625C9.65482 5.625 9.375 5.90482 9.375 6.25C9.375 6.59518 9.65482 6.875 10 6.875H14.9653C15.3105 6.875 15.5903 6.59518 15.5903 6.25C15.5903 5.90482 15.3105 5.625 14.9653 5.625H10Z"
            fill="#007AB8"
          />
          <path
            d="M10 9.375C9.65482 9.375 9.375 9.65482 9.375 10C9.375 10.3452 9.65482 10.625 10 10.625H14.9653C15.3105 10.625 15.5903 10.3452 15.5903 10C15.5903 9.65482 15.3105 9.375 14.9653 9.375H10Z"
            fill="#007AB8"
          />
          <path
            d="M10 13.125C9.65482 13.125 9.375 13.4048 9.375 13.75C9.375 14.0952 9.65482 14.375 10 14.375H15C15.3452 14.375 15.625 14.0952 15.625 13.75C15.625 13.4048 15.3452 13.125 15 13.125H10Z"
            fill="#007AB8"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13.8186 1.25H6.18135C5.44583 1.24999 4.85576 1.24999 4.37861 1.28897C3.88834 1.32903 3.4625 1.41334 3.07003 1.61331C2.44283 1.93289 1.93289 2.44283 1.61331 3.07003C1.41334 3.4625 1.32903 3.88834 1.28897 4.37861C1.24999 4.85576 1.24999 5.44583 1.25 6.18135V13.8186C1.24999 14.5542 1.24999 15.1442 1.28897 15.6214C1.32903 16.1117 1.41334 16.5375 1.61331 16.93C1.93289 17.5572 2.44283 18.0671 3.07003 18.3867C3.4625 18.5867 3.88834 18.671 4.37861 18.711C4.85576 18.75 5.44582 18.75 6.18134 18.75H13.8187C14.5542 18.75 15.1442 18.75 15.6214 18.711C16.1117 18.671 16.5375 18.5867 16.93 18.3867C17.5572 18.0671 18.0671 17.5572 18.3867 16.93C18.5867 16.5375 18.671 16.1117 18.711 15.6214C18.75 15.1442 18.75 14.5542 18.75 13.8187V6.18134C18.75 5.44582 18.75 4.85576 18.711 4.37861C18.671 3.88834 18.5867 3.4625 18.3867 3.07003C18.0671 2.44283 17.5572 1.93289 16.93 1.61331C16.5375 1.41334 16.1117 1.32903 15.6214 1.28897C15.1442 1.24999 14.5542 1.24999 13.8186 1.25ZM13.7917 17.5H7.91667L7.91667 2.5H13.7917C14.5604 2.5 15.0993 2.50049 15.5196 2.53482C15.9326 2.56856 16.1756 2.63185 16.3625 2.72707C16.7545 2.92681 17.0732 3.24552 17.2729 3.63752C17.3681 3.8244 17.4314 4.06743 17.4652 4.4804C17.4995 4.90067 17.5 5.43962 17.5 6.20833V13.7917C17.5 14.5604 17.4995 15.0993 17.4652 15.5196C17.4314 15.9326 17.3681 16.1756 17.2729 16.3625C17.0732 16.7545 16.7545 17.0732 16.3625 17.2729C16.1756 17.3681 15.9326 17.4314 15.5196 17.4652C15.0993 17.4995 14.5604 17.5 13.7917 17.5ZM4.375 6.25C5.06536 6.25 5.625 6.80964 5.625 7.5L5.625 12.5C5.625 13.1904 5.06536 13.75 4.375 13.75C3.68464 13.75 3.125 13.1904 3.125 12.5L3.125 7.5C3.125 6.80964 3.68464 6.25 4.375 6.25Z"
            fill="#007AB8"
          />
        </g>
      </g>
    </SvgIcon>
  );
}

export default CcfWorkItemIcon;
